import { Component, Input } from '@angular/core';

@Component({
  selector: 'signup-tooltip',
  templateUrl: './signup-tooltip.component.html',
})

export class SignupTooltipComponent {
  @Input() text = '';
  @Input() title = '';
  @Input() originElementX: number;
  @Input() originElementWidth: number;

  constructor() { }

}
